export var composeDecorations = function composeDecorations(transformers) {
  return function (_ref) {
    var decorationSet = _ref.decorationSet,
      tr = _ref.tr;
    return transformers.reduce(function (decorationSet, transform) {
      return transform({
        decorationSet: decorationSet,
        tr: tr
      });
    }, decorationSet);
  };
};